<div class="flex items-center border border-primary rounded-lg overflow-hidden">
    <input type="text"
           [formControl]="searchTerm"
           (keydown.enter)="doSearch(searchTerm.value)"
           class="flex-1 px-3 py-2 border-none focus:ring-0 focus:outline-none text-base placeholder-disabled"
           [placeholder]="'nav.searchPlaceholder' | translate"
           aria-label="Search input">
    <button (click)="doSearch(searchTerm.value)"
            class="bg-primary px-3 py-2 text-white hover:bg-primary-600 transition-colors shrink-0">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
        </svg>
    </button>
</div>
